import * as React from 'react';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
formGroup: {
  columnGap: "1.25rem"
},
controlLabel: {
  },
label: {
  height: "auto"
},
radio:{
  display: "flex",
  rowGap: "0.75rem"
}
})

export default function RadioOptions(props) {

    const {label, value, options, loading, onChange, disabled} = props;
    const classes = useStyles()

  return (
    <FormControl>
      {label && <FormLabel id="radio-label">{label}</FormLabel>}
      <RadioGroup
        row
        value={value}
        name="radio"
        classes={{root: classes.formGroup}}
      >
        {Array.isArray(options) && options.map((o)=>
        <FormControlLabel key={`radio-${o[Object.keys(o)[0]].toString()}`} classes={{root: classes.root, label: classes.controlLabel}} 
        value={o[Object.keys(o)[0]].toString()} 
        control={
          <Radio disabled={disabled} classes={{root: classes.radio}} onClick={disabled? null : (e)=> onChange(e)} 
          checkedIcon={<div style={{pointerEvents: "none"}} className="dx-checkbox-checked dx-checkbox-container"><span className="dx-checkbox-icon"></span></div>}
          icon={<div style={{pointerEvents: "none"}} className="dx-checkbox-container"><span className="dx-checkbox-icon"></span></div>}
          />
        } 
        label={o[Object.keys(o)[1]]} 
        disabled={loading}/>)}
      </RadioGroup>
    </FormControl>
  );
}
